import { Box, Card, CardContent, Divider, Grid, Skeleton } from "@mui/material";

interface StepSimulationSkeletonProps {
  cardsCount?: number;
}

const StepSimulationSkeleton = ({
  cardsCount = 4
}: StepSimulationSkeletonProps) => {
  return (
    <Box className="w-full mt-8">
      <Box className="w-full ml-4 pr-8">
        {/* KpiBudgetCard Skeleton */}
        <Grid container spacing={3} justifyContent="center" className="pb-4">
          <Grid
            size={{ xs: 12, sm: 12, md: 9 }}
            sx={{ justifyContent: "center" }}
          >
            <Grid container spacing={2} justifyContent="center">
              {Array.from({ length: cardsCount }).map((_, index) => (
                <Grid
                  size={{ xs: 12, sm: 12, md: 12 / cardsCount }}
                  sx={{ justifyContent: "center" }}
                  key={`metric-card-skeleton-${index}`}
                >
                  <Card className="w-full mt-4">
                    <CardContent>
                      <Box className="w-full flex mb-3">
                        <Skeleton
                          variant="rounded"
                          width={80}
                          height={32}
                          sx={{ mr: 2, borderRadius: 1 }}
                        />
                        <Skeleton variant="text" width={60} height={32} />
                      </Box>
                      <Box className="w-full flex mb-2">
                        <Box className="w-2/5">
                          <Skeleton variant="text" width="80%" />
                        </Box>
                        <Box className="w-2/5">
                          <Skeleton variant="text" width="90%" height={32} />
                        </Box>
                        <Box className="w-1/5">
                          <Skeleton variant="text" width="60%" />
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 12, md: 3 }}
            sx={{ justifyContent: "center" }}
          >
            {/* Total Card Skeleton */}
            <Card className="w-full mt-4">
              <CardContent>
                <Box className="w-full flex mb-3">
                  <Skeleton
                    variant="rounded"
                    width={60}
                    height={32}
                    sx={{ mr: 2, borderRadius: 1 }}
                  />
                  <Skeleton variant="text" width={60} height={32} />
                </Box>
                <Box className="w-full flex mb-2">
                  <Box className="w-2/5">
                    <Skeleton variant="text" width="80%" />
                  </Box>
                  <Box className="w-2/5">
                    <Skeleton variant="text" width="90%" height={32} />
                  </Box>
                  <Box className="w-1/5">
                    <Skeleton variant="text" width="60%" />
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* KpiBudgetCharts Skeleton */}
        <Card className="w-full mt-4">
          <CardContent>
            <Grid container spacing={3} justifyContent="center">
              {/* Bar Chart Skeleton */}
              <Grid
                size={{ xs: 12, sm: 12, md: 6 }}
                sx={{ justifyContent: "center" }}
              >
                <Box className="pt-4 pl-6">
                  <Skeleton variant="text" width={250} height={40} />
                </Box>
                <Box sx={{ height: "500px", p: 3 }}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </Grid>

              {/* Line Chart Skeleton */}
              <Grid
                size={{ xs: 12, sm: 12, md: 6 }}
                sx={{ justifyContent: "center" }}
              >
                <Box className="pt-4 pl-6">
                  <Skeleton variant="text" width={250} height={40} />
                </Box>
                <Box sx={{ height: "500px", p: 3 }}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{ borderRadius: 1 }}
                  />
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* Divider */}
        <Divider className="pt-12" variant="middle" component="div" />

        {/* General Information Section Skeleton */}
        <Box className="w-full mt-8 pl-4">
          <Skeleton variant="text" width={180} height={32} className="mb-4" />
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 6, md: 6 }} sx={{ marginTop: 2 }}>
              {/* Scenario Name Field */}
              <Box className="w-full mt-4">
                <Skeleton
                  variant="rounded"
                  height={56}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
              {/* Scenario Description Field */}
              <Box className="w-full mt-4">
                <Skeleton
                  variant="rounded"
                  height={56}
                  sx={{ borderRadius: 1 }}
                />
              </Box>
              {/* Favorite Switch */}
              <Box className="w-full mt-4 flex items-center">
                <Skeleton variant="text" width={100} height={24} />
                <Skeleton
                  variant="rounded"
                  width={40}
                  height={24}
                  sx={{ ml: 2, borderRadius: 3 }}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default StepSimulationSkeleton;
